import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './Press.css';

class Press extends Component {
  render() {
    return (
      <div className="Press" ref={div => (this.appContainer = div)}>
        <Header />
        <div className="Press-container">
          <div className="Press-top"></div>
          <div className="Press-mid">
            <div className="Press-header">PRESS</div>
            <hr />
            <div className="Press-title">
              <a
                href="http://pasadenamag.com/experience-imagined-apocalypse-pasadenas-bunker-experience/"
                target="_blank"
                rel="noopener noreferrer"
              >
                PASADENA MAGAZINE
              </a>

              <div className="text">
                "There's a rich story going on around you and, at times, it feels as though you’ve
                wandered into the middle of a play, watching the action from center stage before
                taking on a role yourself. The lines between you and the game are blurry, a
                phenomenon that begins almost immediately upon your arrival. The Bunker Experience
                is a thrilling and exciting world to dive into, as long as you can find the key that
                lets you out."
              </div>

              <br />
              <hr />

              <a href="https://kiisfm.iheart.com" target="_blank" rel="noopener noreferrer">
                JOJO ON THE RADIO (KIIS FM 102.7)
              </a>

              <div className="text">
                "Dear Bunker Experience, thanks for TRAUMATIZING us! LOVED IT!!! Best Escape Room
                EVER!!!"
              </div>

              <br />
              <hr />

              <a
                href="http://laist.com/2016/09/09/bunker_experience.php"
                target="_blank"
                rel="noopener noreferrer"
              >
                LAIST
              </a>

              <div className="text">
                "You're in the story from the moment you open the door and the panicked survivor
                waives you inside. The game also ends differently from other rooms. Actually
                escaping is not as simple as unlocking a door and leaving: players will be required
                to navigate a maze, similar to those found in haunted house attractions at
                Halloween."
              </div>

              <br />
              <hr />

              <a
                href="http://fanboynation.com/bunker-experience/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Fanboy Nation
              </a>

              <div className="text">
                "The Bunker Experience is one of the top three rooms I’ve experienced in terms of
                production value. So far, it is the only escape room to scare me good… to the point
                it made me walk to the opposite end of the room, and say, “NOPE!” With how great The
                Bunker Experience was, I’m excited to see the twists and the set the staff creates
                for the next escape room."
              </div>

              <br />
              <hr />

              <a
                href="http://horrorbuzz.com/bunker-experience-fantastic-fun/"
                target="_blank"
                rel="noopener noreferrer"
              >
                HorrorBuzz
              </a>

              <div className="text">
                "It begins the moment you walk down the stairs, quite literally into a basement,
                where the theming starts right off the bat. One of the best beginnings to any escape
                room I have ever seen. One of the greatest strengths about the entire thing was the
                location itself; it lent itself naturally to the storyline, and The Bunker’s team
                wisely exploited that. Overall, The Bunker Experience was fantastic fun, and a great
                twist on traditional escape rooms."
              </div>

              <br />
              <hr />

              <a
                href="https://allhallowshaunts.wordpress.com/2016/08/08/will-you-escape-the-bunker-experience/"
                target="_blank"
                rel="noopener noreferrer"
              >
                All Hallows Hauns
              </a>

              <div className="text">
                "In Pasadena California, there is an escape room that combines it all into one of
                the most epic adventures anyone could have- The Bunker Experience. I highly
                recommend the Bunker Experience to everyone. It’s fun, it’s scary, it’s challenging,
                and it’s an adventure. You will have fun. You will be scared. I will tell you that
                they were some of the most clever and trickiest tasks I could’ve imagined.I cannot
                even begin to describe how much fun we had. As soon as we entered, we were thrust
                into this incredible story of survival."
              </div>

              <br />
              <hr />

              <a
                href="http://gamingshogun.com/2016/08/18/bunker-experience-escape-room-review/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Gaming Shogun
              </a>

              <div className="text">
                "The Bunker Experience is a lot of fun, and features a terrific environment for an
                escape room. One of the coolest things about The Bunker Experience is that it also
                features a short walk-through dark maze similar to a haunted house."
              </div>

              <br />
              <hr />

              <a
                href="https://www.thrillist.com/venues/the-bunker-experience"
                target="_blank"
                rel="noopener noreferrer"
              >
                Thrillist
              </a>

              <div className="text">
                The experience is very Maze Runner-esque, with a plot that's set 60+ years in the
                future with all inhabitants (that's you) living in maze-like underground tunnels
                that, obviously, you need to escape from. Like, pronto.
              </div>

              <br />
              <hr />

              <a
                href="http://www.hauntedattractionspodcast.com/the-haunt-journal/"
                target="_blank"
                rel="noopener noreferrer"
              >
                The Haunt Journal
              </a>

              <div className="text">
                "The Bunker Experience is based off of a web series, and is found on a solid story
                foundation that will fully engage participants in the story. The participants
                themselves are active, essential players in this story. Rather than simply following
                instructions, they must make decisions to drive the story forward, and they must do
                so as a team."
              </div>

              <br />
              <hr />

              <a
                href="http://fangirlnation.com/2015/10/23/the-bunker-experience-escape-or-die-trying/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Fangirl Nation
              </a>

              <div className="text">
                "I did get the pants scared off of me in there. This experience really forces you to
                leave your warm little comfort zone and thrust yourself into the cold reality of a
                post-apocalyptic world where you are either going to escape or die trying. I loved
                this room and I am excited to see how others experience it!"
              </div>
            </div>
          </div>
          <div className="Press-bottom"></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Press;
